<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Marżowość'" [name]="'Lista'"></app-breadcrumb>
<div class="commission-margin-report-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" [formGroup]="actionForm"  fxLayoutGap="15px" fxLayoutAlign="start center">
      <app-month-picker
        class="commission-margin-report-filter"
        label="Miesiąc rozliczeniowy" [required]="true"
        [control]="billingMonthControl"
      ></app-month-picker>
    <button
      (click)="generateMargin()" mat-raised-button
      [disabled]="!actionForm.valid || disabledGenerateMargin"
      color="primary"><mat-icon>play_arrow</mat-icon> <span> Generuj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">


    <span fxFlex></span>
  </div>
  <div fxLayout="column">
    <table mat-table [dataSource]="commissionMarginReportObject" matSort (matSortChange)="sortChanged($event)" [trackBy]="trackTask">
      <ng-container matColumnDef="billingMonth" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header="billingMonth"> Miesiąc rozliczeniowy </th>
        <td mat-cell *matCellDef="let element">
          <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="start center" >
            {{element.billingMonth}}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="requestedAt"> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.requestedAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="parameters">
        <th mat-header-cell *matHeaderCellDef> Liczba wierszy </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.result?.length > 0">
            <ng-container *ngFor="let item of element.result">
              <span>{{item.key}}: {{item.value}}</span><br>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="commission-margin-report-buttons-td">
            <button *ngIf="(userPermissions | async)?.settlement.margin"
                    [disabled]="!(userPermissions | async)?.settlement.margin || !element.success"
                    (click)="download(element)"
                    mat-stroked-button color="primary">
              <mat-icon>download</mat-icon> <span> Pobierz</span></button>
            <button *ngIf="(userPermissions | async)?.settlement.admin_root" [disabled]="!(userPermissions | async).settlement.admin_root" (click)="delete(element)" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>

          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
